let temp: FreeObjMap = {};

export default temp;
